import { env } from 'config/env';

import { createApiClient } from './__GENERATED';
import { getUser } from './OIDC/api';

const apiClient = createApiClient(env.VITE_API_BASE);

// Attach the OIDC bearer at the axios layer rather than as a Zodios plugin,
// so raw `apiClient.axios.*` calls (used when an endpoint needs response
// headers — e.g. x-pagination) get authenticated too.
apiClient.axios.interceptors.request.use(async (config) => {
  const token = (await getUser())?.access_token;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { apiClient };
